export const fragment = hash => `${window.location.pathname}${window.location.search}#${hash}`;
